import { Button } from '@/components/Button';
import { MdGroupAdd, MdLinkOff } from 'react-icons/md';

interface Props {
  selectedCount: number;
  onDeselectAll: () => void;
  onCopy: () => void;
  onToSuggest: () => void;
  onToWithdraw: () => void;
  onToSelection: () => void;
  onDelete: () => void;
  showToSuggest: boolean;
  showToWithdraw: boolean;
  showToSelection: boolean;
  showDelete: boolean;
  isLoading?: boolean;
}

export default function CandidatesOfferSelectionBar({
  selectedCount,
  onDeselectAll,
  onCopy,
  onToSuggest,
  onToWithdraw,
  onToSelection,
  onDelete,
  showToSuggest,
  showToWithdraw,
  showToSelection,
  showDelete,
  isLoading = false,
}: Props) {
  if (selectedCount === 0) return null;

  return (
    <div className="sticky bottom-0 z-50 flex w-full items-center justify-between gap-2 bg-white px-6 py-4 shadow-layer3">
      <div className="flex items-baseline gap-2">
        <span className="text-lg font-bold">{selectedCount}件</span>
        <span className="text-sm">選択中</span>
        <Button color="secondary" size="md" onClick={onDeselectAll} disabled={isLoading}>
          <MdLinkOff className="size-icon-xs" />
          選択解除
        </Button>
        <Button color="secondary" size="md" onClick={onCopy} disabled={isLoading}>
          <MdGroupAdd className="size-icon-xs" />
          提案求人をコピーする
        </Button>
      </div>

      <div className="flex items-center gap-2">
        {showToSuggest && onToSuggest && (
          <Button
            color="danger-secondary"
            size="md"
            onClick={onToSuggest}
            className="w-[120px]"
            disabled={isLoading}
          >
            提案へ戻す
          </Button>
        )}
        {showToWithdraw && onToWithdraw && (
          <Button
            color="danger-secondary"
            size="md"
            onClick={onToWithdraw}
            className="w-[120px]"
            disabled={isLoading}
          >
            取り下げ
          </Button>
        )}
        {showToSelection && onToSelection && (
          <Button
            color="primary"
            size="md"
            onClick={onToSelection}
            className="w-[120px]"
            disabled={isLoading}
          >
            選考へ進む
          </Button>
        )}
        {/* 取り下げ済みが選択中の場合のみ表示 */}
        {showDelete && onDelete && (
          <Button
            color="danger-secondary"
            size="md"
            onClick={onDelete}
            className="w-[120px]"
            disabled={isLoading}
          >
            削除
          </Button>
        )}
      </div>
    </div>
  );
}
